(ns hypnos.sleeplab.tile.field.patient-contact
  "Fields for the patient contact information (mobile phone number and email
  address."
  (:require [clojure.string :as str]
            [hypnos.graphql.mutations :as mutations]
            [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]
            [reagent.core :as reagent]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; identitiies

(def ^{:const true} phone-number-regex
  #"^[2-9][0-8][0-9][2-9][0-9]{2}[0-9]{4}$")

(def ^{:const true} email-regex
  #"^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$")

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; helpers

(defn valid-email?
  [s]
  (and (not (str/blank? s))
       (re-find email-regex s)))

(defn valid-phone-number?
  [^String s]
  (and (not (str/blank? s))
       (re-find phone-number-regex s)))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; field

(defn contact-field
  ([state]
   (contact-field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal
     [:label.label (tr :ui.label/contact)]]
    [:div.field-body
     [:div.field.is-expanded
      [:div.field.has-addons
       [:p.control
        [:a.button.is-static " +1 "]]
       [:p.control.is-expanded
        [:input.input
         {:type        :tel
          :max-length  10
          :class       (when (not (or (nil? (get-in @state [:patient :patient/phone-number :valid?]))
                                      (get-in @state [:patient :patient/phone-number :valid?])))
                         "is-danger")
          :disabled    disabled
          :placeholder (when-not disabled (tr :ui.placeholder/phone-number))
          :value       (get-in @state [:patient :patient/phone-number :value])
          :on-change   (fn [e]
                         (let [val                 (-> e .-target .-value)
                               old-value           (get-in @state [:patient :patient/phone-number :value])
                               new-value           (when-not (str/blank? val)
                                                     (str/replace val #"[^0-9]" ""))
                               changed?            (or (get-in @state [:patient :patient/phone-number :dirty?])
                                                       (not= new-value old-value))
                               _touched?           (get-in @state [:patient :patient/phone-number :touched?])
                               valid?              (get-in @state [:patient :patient/phone-number :valid?])
                               valid-phone-number? (valid-phone-number? new-value)]
                           (swap! state assoc-in
                                  [:patient :patient/phone-number :value]
                                  new-value)
                           (swap! state assoc-in
                                  [:patient :patient/phone-number :dirty?]
                                  changed?)
                           (swap! state assoc-in
                                  [:patient :patient/phone-number :valid?]
                                  (cond
                                    (and changed?
                                         (not (nil? valid?))
                                         (not valid-phone-number?)) false
                                    (and changed?
                                         valid-phone-number?)       true
                                    :else                           nil))))
          :on-focus    (fn [_]
                         (swap! state assoc-in
                                [:patient :patient/phone-number :touched?]
                                true))
          :on-blur     (fn [_]
                         (swap! state assoc-in
                                [:patient :patient/phone-number :valid?]
                                (not (nil? (valid-phone-number? (get-in @state
                                                                        [:patient :patient/phone-number :value]))))))}]]]
      (when-not disabled
        [:p.help
         {:class (when (not (or (nil? (get-in @state [:patient :patient/phone-number :valid?]))
                                (get-in @state [:patient :patient/phone-number :valid?])))
                   "is-danger")}
         (tr :ui.help/phone-number)])]
     [:div.field
      [:p.control.is-expanded.has-icons-left
       [:input.input
        {:type        :email
         :class       (when (not (or (nil? (get-in @state [:patient :patient/email :valid?]))
                                     (get-in @state [:patient :patient/email :valid?])))
                        "is-danger")
         :disabled    disabled
         :placeholder (when-not disabled (tr :ui.placeholder/email))
         :value       (get-in @state [:patient :patient/email :value])
         :on-change   (fn [e]
                        (let [old-value (get-in @state [:patient :patient/email :value])
                              new-value (-> e .-target .-value)
                              changed?  (or (get-in @state [:patient :patient/email :dirty?])
                                            (not= new-value old-value))]
                          (swap! state assoc-in
                                 [:patient :patient/email :value]
                                 new-value)
                          (swap! state assoc-in
                                 [:patient :patient/email :dirty?]
                                 changed?)
                          (when (valid-email? new-value)
                            (swap! state assoc-in
                                   [:patient :patient/email :valid?]
                                   true))))
         :on-focus    (fn [_]
                        (swap! state assoc-in
                               [:patient :patient/email :touched?]
                               true))
         :on-blur     (fn [_]
                        (swap! state assoc-in
                               [:patient :patient/email :valid?]
                               (not (nil? (valid-email? (get-in @state [:patient :patient/email :value]))))))}]
       [:span.icon.is-small.is-left
        [:i.mdi.mdi-mail]]]
      (when-not disabled
        [:p.help
         {:class (when (not (or (nil? (get-in @state [:patient :patient/email :valid?]))
                                (get-in @state [:patient :patient/email :valid?])))
                   "is-danger")}
         (tr :ui.help/email)])]]]))

(defn alt-contact-field
  ([state]
   (alt-contact-field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal
     [:label.label (tr :ui.label/alt-contact)]]
    [:div.field-body
     [:div.field
      [:div.field.has-addons
       [:p.control
        [:a.button.is-static " +1 "]]
       [:p.control
        [:input.input
         {:type        :tel
          :max-length  10
          :class       (when (not (or (nil? (get-in @state [:patient :patient/alt-phone-number :valid?]))
                                      (get-in @state [:patient :patient/alt-phone-number :valid?])))
                         "is-danger")
          :disabled    disabled
          :placeholder (when-not disabled (tr :ui.placeholder/phone-number))
          :value       (get-in @state [:patient :patient/alt-phone-number :value])
          :on-change   (fn [e]
                         (let [val                 (-> e .-target .-value)
                               old-value           (get-in @state [:patient :patient/alt-phone-number :value])
                               new-value           (when-not (str/blank? val)
                                                     (str/replace val #"[^0-9]" ""))
                               changed?            (or (get-in @state [:patient :patient/alt-phone-number :dirty?])
                                                       (not= new-value old-value))
                               _touched?           (get-in @state [:patient :patient/alt-phone-number :touched?])
                               valid?              (get-in @state [:patient :patient/alt-phone-number :valid?])
                               valid-phone-number? (valid-phone-number? new-value)]
                           (swap! state assoc-in
                                  [:patient :patient/alt-phone-number :value]
                                  new-value)
                           (swap! state assoc-in
                                  [:patient :patient/alt-phone-number :dirty?]
                                  changed?)
                           (swap! state assoc-in
                                  [:patient :patient/alt-phone-number :valid?]
                                  (cond
                                    (and changed?
                                         (not (nil? valid?))
                                         (not valid-phone-number?)) false
                                    (and changed?
                                         valid-phone-number?)       true
                                    :else                           nil))))
          :on-focus    (fn [_]
                         (swap! state assoc-in
                                [:patient :patient/alt-phone-number :touched?]
                                true))
          :on-blur     (fn [_]
                         (swap! state assoc-in
                                [:patient :patient/alt-phone-number :valid?]
                                (not (nil? (valid-phone-number? (get-in @state
                                                                        [:patient :patient/alt-phone-number :value]))))))}]]]
      (when-not disabled
        [:p.help
         {:class (when (not (or (nil? (get-in @state [:patient :patient/alt-phone-number :valid?]))
                                (get-in @state [:patient :patient/alt-phone-number :valid?])))
                   "is-danger")}
         (tr :ui.help/alt-phone-number)])]]]))

(defn one-time-contact-field
  "Handles one-time contact."
  [_patient]
  (let [ot-phone-number (reagent/atom {:value  nil
                                       :valid? true})]
    (fn [patient]
      (let [communication (rf/subscribe [:sleeplab/communication])]
        [:div
         [:div.field.is-horizontal
          [:div.field-label.is-normal
           [:label.label (tr :ui.label/one-time-contact)]]
          [:div.field-body
           [:div.field
            [:div.field.has-addons
             [:p.control
              [:a.button.is-static " +1 "]]
             [:p.control
              [:input.input
               {:type        :tel
                :max-length  10
                :placeholder (tr :ui.placeholder/phone-number)
                :value       (:value @ot-phone-number)
                :on-change   (fn [e]
                               (let [val                 (-> e .-target .-value)
                                     new-value           (when-not (str/blank? val)
                                                           (str/replace val #"[^0-9]" ""))
                                     valid-phone-number? (valid-phone-number? new-value)]
                                 (swap! ot-phone-number assoc :value val)
                                 (swap! ot-phone-number assoc :valid? (not (not valid-phone-number?)))))}]]]
            [:p.help (tr :ui.help/one-time-phone-number)]]
           [:button.button.is-success
            {:disabled (or (not (:valid? @ot-phone-number))
                           (:status @communication))
             :on-click (fn [_]

                         (when (:valid? @ot-phone-number)
                           (let [communication-type (if (and (= :consult-state/pending
                                                                (get-in patient [:patient/last-consult :consult/status]))
                                                             (nil? (get-in patient [:patient/image])))
                                                      "portrait"
                                                      "consult")]
                             (rf/dispatch-sync [:sleeplab/set-communication-status :sending])
                             (rf/dispatch [:amplify/mutation
                                           mutations/send-communication
                                           {:consult_id            (str (get-in patient [:patient/last-consult :consult/id]))
                                            :communication_channel "sms"
                                            :communication_type    communication-type
                                            :ot_phone_number       (:value @ot-phone-number)}
                                           :sleeplab/set-communication]))))}
            [:span.icon [:i.mdi.mdi-message-bulleted.default]]
            [:span (tr :ui.label/send)]]]]
         (case (:status @communication)
           :sending [:div.notification.is-info.is-light (tr :ui.communication-message/sending)]
           :send [:div.notification.is-info.is-light (tr :ui.communication-message/send)]
           nil)]))))
